import React, { useEffect } from "react";
import { withRouter } from 'react-router-dom';
import ErrorPage from './ErrorPage';
import { connect } from "react-redux";

class NotAuthorized extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <ErrorPage mainText="Acceso denegado"></ErrorPage>
        )
    }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(NotAuthorized)
);